module.exports = __webpack_public_path__ + "static/img/p21.47376ea3.png";